import React from "react";

export default function Contact() {
  return (
    <div className="row align-items-center g-lg-5 py-5">
      <div className="col-lg-7 text-center text-lg-start">
        <h2 className="display-5 fw-bold lh-1 text-body-emphasis mb-3">
          Contact Us
        </h2>
        <p className="col-lg-10 fs-4">
          Have questions, feedback, or special requests? We'd love to hear from
          you! Fill out the form below, and our team will get back to you as
          soon as possible.
        </p>
      </div>

      <div className="col-md-10 mx-auto col-lg-5">
        <form className="p-4 p-md-5 border rounded-3 bg-body-tertiary">
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="floatingName"
              placeholder="Your Name"
            />
            <label htmlFor="floatingName">Name</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="email"
              className="form-control"
              id="floatingEmail"
              placeholder="name@example.com"
            />
            <label htmlFor="floatingEmail">Email Address</label>
          </div>
          <div className="form-floating mb-3">
            <textarea
              className="form-control"
              id="floatingMessage"
              placeholder="Your Message"
              style={{ height: "100px" }}
            ></textarea>
            <label htmlFor="floatingMessage">Message</label>
          </div>
          <button className="w-100 btn btn-lg btn-dark" type="submit">
            Send Message
          </button>
          <hr className="my-4" />
          <small className="text-body-secondary">
            By submitting this form, you agree to our terms of service.
          </small>
        </form>
      </div>
    </div>
  );
}
